import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExp } from 'src/app/core/config/regex';
import { Context, Role } from 'src/app/shared/models/context';
import { Employee, EmployeeData, Image, Message, Timeline, Title } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { CompanyService } from 'src/app/shared/services/company.service';
import { ContextService } from 'src/app/shared/services/context.service';
import { DataService } from 'src/app/shared/services/data.service';
import { DomainService } from 'src/app/shared/services/domain.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { SettingsService } from 'src/app/shared/services/settings.service';
@Component({
  selector: 'app-employee-crud',
  templateUrl: './employee-crud.component.html',
  styleUrls: ['./employee-crud.component.scss'],
})
export class EmployeeCrudComponent implements OnInit {
  @Input() employee: EmployeeData;
  @Input() context: Context;
  @Input() roles: Role[] = [];
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  public desiginationForm: FormGroup;
  public titles: Title[] = [];
  public onLoad: boolean = false;
  public surnames: string[] = [];
  public employeeForm: FormGroup;
  public imageForm: FormGroup;
  public submitted: boolean = false;
  public isTitleSubmitted: boolean = false;
  public genders: string[] = [];
  public bloods: string[] = [];
  public modified: boolean = false;
  public isLoading: boolean = true;
  public reports: EmployeeData[] = [];
  private imgFormat: any
  private imageUrl: string;
  public image: string;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private contextService: ContextService,
    private companyService: CompanyService,
    private commonService: CommonService,
    private settingsService: SettingsService,
    private employeeService: EmployeeService,
    private datePipe: DatePipe,
    private dataService: DataService,
    private domainService: DomainService,
  ) { }

  ngOnInit(): void {
    this.setEmployeeForm(this.employee);
    this.setDesiginationForm(undefined);
    this.getLatestTimeline();
    this.surnames = this.commonService.getSurnames();
    this.contextService.getGenders().subscribe((genders) => (this.genders = genders));
    this.contextService.getBloodGroups().subscribe((bloods) => (this.bloods = bloods));
    this.settingsService.getRoles(this.context.companyId,false).subscribe((roles: Role[]) => this.roles = roles.filter(r => r.persona !== 'CLIENT'));
    this.companyService.getEmployees(this.context?.companyId).subscribe((report: EmployeeData[]) => { this.reports = report.filter(emp => emp.employeeData?.id !== this.employee?.employeeData?.id) });
    if (this.context.companyId) {
      this.settingsService.getTitles(this.context.companyId, null, null, false).subscribe((titles) => (this.titles = titles));
    }
  }

  public showPassword(value) {
    this.commonService.showPassword(value);
  }

  private setEmployeeForm(employee?: EmployeeData) {
    if (!employee)
      employee = {
        employeeData: {
          id: null,
          name: null,
          surname: null,
          code: null,
          dob: null,
          doj: null,
          gender: null,
          email: null,
          aadhaar: null,
          pan: null,
          avatar: null,
          title: 'Mr',
          blood: null,
          addressId: null,
          userId: null,
          reportTo: null,
          addressTo: null,
          salaried: true,
          disabled: false,
        },
        userData: {
          id: null,
          username: null,
          roleName: null,
          password: null,
          roleId: null,
          session: null,
          client: null,
          timestamp: null,
          verified: true,
          disabled: false,
          companyId: this.context?.companyId,
          confirm: '',
        }
      } as EmployeeData;
    this.employeeForm = this.fb.group({
      employeeData: this.fb.group({
        id: this.fb.control(employee?.employeeData?.id, []),
        name: this.fb.control(employee?.employeeData?.name, [Validators.required, Validators.pattern(RegExp.letters)]),
        surname: this.fb.control(employee?.employeeData?.surname, [Validators.required]),
        code: this.fb.control(employee?.employeeData?.code, []),
        dob: this.fb.control(employee?.employeeData?.dob, [Validators.required]),
        doj: this.fb.control(employee?.employeeData?.doj, [Validators.required]),
        gender: this.fb.control(employee?.employeeData?.gender, [Validators.required]),
        email: this.fb.control(employee?.employeeData?.email, [Validators.required, Validators.pattern(RegExp.email)]),
        aadhaar: this.fb.control(employee?.employeeData?.aadhaar, [Validators.required, Validators.pattern(RegExp.aadharNumber)]),
        pan: this.fb.control(employee?.employeeData?.pan, [Validators.pattern(RegExp.pan)]),
        avatar: this.fb.control(employee?.employeeData?.avatar, []),
        title: this.fb.control(employee?.employeeData?.title, []),
        blood: this.fb.control(employee?.employeeData?.blood, [Validators.required]),
        addressId: this.fb.control(employee?.employeeData?.addressId, []),
        userId: this.fb.control(employee?.employeeData?.userId, []),
        reportTo: this.fb.control(employee?.employeeData?.reportTo, []),
        addressTo: this.fb.control(employee?.employeeData?.addressTo, []),
        salaried: this.fb.control(employee?.employeeData?.salaried, []),
        disabled: this.fb.control(employee?.employeeData?.disabled, []),
      }),
      userData: this.fb.group({
        id: this.fb.control(employee?.userData?.id, []),
        patronId: this.fb.control(employee?.userData?.patronId || null, []),
        username: this.fb.control(employee?.userData?.username, [Validators.required, Validators.pattern(RegExp.email)]),
        password: this.fb.control(employee?.userData?.password, [!employee?.userData?.id ? Validators.required : Validators.nullValidator, Validators.pattern(RegExp.password)]),
        roleId: this.fb.control(employee?.userData?.roleId, [Validators.required]),
        roleName: this.fb.control(employee?.userData?.roleName, []),
        session: this.fb.control(employee?.userData?.session, []),
        client: this.fb.control(employee?.userData?.client, []),
        timestamp: this.fb.control(employee?.userData?.timestamp, []),
        companyId: this.fb.control(employee?.userData?.companyId, [Validators.required]),
        verified: this.fb.control(employee?.userData?.verified, []),
        disabled: this.fb.control(employee?.userData?.disabled, []),
        confirm: this.fb.control(employee?.userData?.confirm, [!employee.userData.id ? Validators.required : Validators.nullValidator, Validators.pattern(RegExp.password)]),
        avatarUrl: this.fb.control(employee?.userData?.avatarUrl || null, []),
      })
    }),
      this.employeeForm.valueChanges.subscribe(value => this.modified = true);
  }

  get e() {
    return this.employeeForm.controls;
  }
  get u() {
    return this.e.employeeData as FormGroup;
  }
  get a() {
    return this.e.userData as FormGroup;
  }

  private getEmployee(id: number, resetDesigination: boolean = false) {
    this.companyService.getEmployee(id).subscribe(employee => {
      if (employee.employeeData.id) {
        this.setEmployeeForm(employee);
        if (resetDesigination) this.setDesiginationForm(undefined);
      }
    });
  }

  public async getAndSetBase64(event: any) {
    const image: string = await this.commonService.convertImgToBase64(event);
    if (!image) return;
    this.imageUrl = image;
  }


  private saveImage(sid: number, refType: string, label: string, url: string) {
    let image: Image = {
      id: null,
      sid: sid,
      type: refType,
      label: label,
      image: url,
    };
    image.image = url
    this.domainService.createImage(image).subscribe({
      next: (response: string) => {
      },
      error: (error: HttpErrorResponse) => {
      }
    });
  }

  private getImage(id:number) {
    this.domainService.getImage('EMPLOYEE', 'EMPLOYEE', id, 'avatar').subscribe(image => {
      this.image = image.payload;
    });
  }

  public saveEmployee(inProgress?: any) {
    this.submitted = true;
    if (this.employeeForm.valid) {
      let employee: EmployeeData = this.employeeForm.value;
      if (!this.modified) {
        this.commonService.setToastr(200, `Employee ${employee.employeeData.name} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (employee.userData.password && employee.userData.confirm !== employee.userData.password) {
        inProgress.value = false;
        return;
      }

      if (employee.employeeData.id) {
        this.companyService.updateEmployee(employee.employeeData.id, employee).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.passEntry.emit(true);
              this.onLoad = true;
              if(this.imageUrl){
              this.saveImage(employee.employeeData.id, 'EMPLOYEE', 'avatar', this.imageUrl);
              this.getImage(employee.employeeData.id);
              }
              inProgress.value = false;
              this.commonService.setToastr(200, `Employee ${employee.employeeData.name} has been updated successfully!`);
              this.dataService.reInitContext();
              this.getEmployee(employee.employeeData.id);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, `Cannot update the record. employee '${employee.employeeData.name}' already exists.`);
            }
            this.submitted = false;
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
          },
        });
      } else {
        this.companyService.createEmployee(employee).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.passEntry.emit(true);
              this.onLoad = true;
              inProgress.value = false;
              this.commonService.setToastr(200, `Employee ${employee.employeeData.name} has been created successfully!`);
              this.dataService.reInitContext();
              this.submitted = false;
              this.getEmployee(parseInt(response.payload), true);
              if(this.imageUrl){
                this.saveImage(parseInt(response.payload), 'EMPLOYEE', 'avatar', this.imageUrl);
                this.getImage(parseInt(response.payload));
              }
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, `Cannot add the record. employee '${employee.employeeData.name}' already exists.`);
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
          },
        });
      }
    }
  }

  private getLatestTimeline() {
    if (!this.employee?.employeeData?.id) return;
    this.employeeService.getNewTimeline(this.employee.employeeData.id).subscribe((timeline: Timeline) => {
      if (timeline.employeeData === null) {
        timeline.employeeData = { id: this.employee.employeeData.id } as Employee;
      }
      this.setDesiginationForm(timeline);
    });
  }

  public setDesiginationForm(desigination?: Timeline) {
    if (!desigination)
      desigination = {
        id: null,
        start: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        end: null,
        label: null,
        active: true,
        disabled: false,
        employeeData: { id: this.u.value.id },
        title: { id: null } as Title,
      } as Timeline;
    this.desiginationForm = this.fb.group({
      id: this.fb.control(desigination?.id),
      start: this.fb.control(this.datePipe.transform(desigination?.start || '', 'yyyy-MM-dd'), [Validators.required]),
      end: this.fb.control(desigination?.end, []),
      label: this.fb.control(desigination?.label, []),
      disabled: this.fb.control(desigination?.disabled, []),
      active: this.fb.control(true, []),
      title: this.fb.group({
        id: this.fb.control(desigination?.title?.id, [Validators.required]),
        name: this.fb.control(desigination?.title?.name || '', []),
      }),
      employeeData: this.fb.group({
        id: this.fb.control(desigination?.employeeData?.id, [Validators.required]),
      }),
    });
    this.desiginationForm.valueChanges.subscribe(value => this.modified = true);
  }

  get f() {
    return this.desiginationForm.controls;
  }

  get g() {
    return this.f.title as FormGroup;
  }

  public saveDesigination(isUpserting?: any) {
    this.isTitleSubmitted = true;
    if (this.desiginationForm.valid) {
      const desigination = this.desiginationForm.value as Timeline;
      isUpserting.value = true;
      if (this.u.value.id) {
        this.employeeService.createTimeline(desigination).subscribe({
          next: (response: Timeline) => {
            if (response) {
              isUpserting.value = false;
              this.commonService.setToastr(200, `Desigination ${response?.title?.name} has been created successfully!`);
              this.setDesiginationForm(response);
            } else {
              isUpserting.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
            this.isTitleSubmitted = false;
          },
          error: (error: HttpErrorResponse) => {
            isUpserting.value = false;
            this.isTitleSubmitted = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }
}

